<template>
  <ul class="nodelist-container">
    <li
      class="nodelist-wrap"
      v-for="(wrapItem, wrapIndex) in wrapList"
      :key="wrapIndex"
    >
      <p class="nodestat-title">
        <van-icon name="location" :color="wrapItem.color" size="0.6rem" />
        <span>{{ wrapItem.name }}：</span>
      </p>
      <ul class="nodelist">
        <li
          class="node"
          v-for="(item, index) in wrapItem.list"
          :key="index"
          @click="onNodeClick(wrapItem, item)"
        >
          <div class="classtime">{{ item.ClassTime }}</div>
          <div class="nodeinfo">
            <p class="nodename">
              <span>{{ item.NodeName }}</span>
              <span class="c999">({{ item.CityName }})</span>
            </p>
            <p>
              <span class="c999">人数：</span>
              <span
                >{{ item.SaleCount + item.BookTicketCount + item.MixCheckedTickets }}人 (含预订:{{
                  item.BookTicketCount
                }}人)</span
              >

              <span
              > (含混检:{{
                  item.MixCheckedTickets
                }}人)</span
              >
            </p>
            <p v-if="wrapItem.code != 'arrival'">
              <span class="c999">已检：</span>
              <span
                >
                (含混检:{{
                  item.MixCheckedTickets
                }}人)
                </span
              >
            </p>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    // 日班次GID
    lineClassDayGID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      wrapList: [
        {
          code: "start",
          name: "上车点统计",
          color: "#ea9518",
          list: [],
        },
        {
          code: "arrival",
          name: "下车点统计",
          color: "#1dfa2c",
          list: [],
        },
      ],
    };
  },
  watch: {
    // 停留在本 tab 时切换线路/班次，GID 变化需重新拉取
    lineClassDayGID: {
      immediate: true,
      handler(val, oldVal) {
        if (!val || val === oldVal) return;
        this.reloadStats();
      },
    },
  },
  methods: {
    reloadStats() {
      this.startNodeQuery();
      this.arrivalNodeQuery();
    },
    startNodeQuery() {
      if (!this.lineClassDayGID) {
        this.wrapList[0].list = [];
        return;
      }
      this.$http
        .post(this.$api.getStartNode, {
          LineClassDayGID: this.lineClassDayGID,
        })
        .then((res) => {
          this.wrapList[0].list = res.data || [];
        });
    },
    arrivalNodeQuery() {
      if (!this.lineClassDayGID) {
        this.wrapList[1].list = [];
        return;
      }
      this.$http
        .post(this.$api.getArrivalNode, {
          LineClassDayGID: this.lineClassDayGID,
        })
        .then((res) => {
          const list = res.data || [];
          list.forEach((i) => {
            i.ClassTime = this.$moment(i.PredictOutTime).format("HH:mm");
          });
          this.wrapList[1].list = list;
        });
    },
    /**
     * 有购票人数时可查看该站点售票详情（只读列表）
     * SaleCount > 0 视为有人购买
     */
    onNodeClick(wrapItem, item) {
      const saleCount = Number(item.SaleCount) || 0;
      if (saleCount <= 0) {
        this.$toast("该站点暂无购票信息");
        return;
      }
      const nodeGID = item.NodeGID || item.StartNodeGID || item.ArrivalNodeGID;
      if (!nodeGID) {
        this.$toast("站点信息不完整");
        return;
      }
      this.$router.push({
        name: "NodeTicketList",
        query: {
          lineClassDayGID: this.lineClassDayGID,
          nodeGID,
          nodeName: item.NodeName || "",
          nodeType: wrapItem.code === "arrival" ? "arrival" : "start",
          classDate: item.ClassDate || "",
          classTime: item.ClassTime || "",
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.nodelist-container {
  background: white;
  font-size: 0.41rem;

  .nodelist-wrap {
    .nodestat-title {
      margin-left: 0.128rem;

      span {
        vertical-align: top;
      }
    }

      .node {
      display: flex;
      margin: 0 0.256rem;
      padding: 0.385rem 0 0.256rem;
      border-bottom: 1px solid #ccc;
      cursor: pointer;

      &:nth-last-child(1) {
        border: 0;
      }

      .classtime {
        font-weight: bolder;
        color: #0f9fff;
        line-height: 0.59rem;
        padding: 0 0.385rem;
      }

      .nodeinfo {
        p {
          margin-bottom: 0.128rem;

          &:nth-child(1) {
            margin-bottom: 0.256rem;
          }
        }
      }
    }
  }
}
</style>
